import { of } from 'rxjs'
import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { CompaniesElasticSearchService } from 'src/services/data/account-elastic.service'
import { TOP_LEVEL_FILTERS } from 'src/pages/admin/settings/company-settings/companies-list/companies-list.filters'
import { prepareFiltersPayload, prepareCompaniesPayload } from './company-view-filters.utils'
import { loadCompanyViews, loadCompanyViewsFailure, loadCompanyViewsSuccess, loadCompanyFilters, loadCompanyFiltersSuccess, loadCompanyFiltersFailure } from './company-view.actions'

@Injectable()
export class CompanyViewEffects {
  private actions$ = inject(Actions)
  private toaster = inject(ToasterService)
  private elastic = inject(CompaniesElasticSearchService)


  loadCompanyViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadCompanyViews),
    map(action => ({
      action,
      payload: prepareCompaniesPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) =>
      this.elastic.search({ ...payload, calculate: action.calculate }).pipe(
        map(r => loadCompanyViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          companyViews: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch companies', loadCompanyViewsFailure
      )))))

  loadCompanyFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadCompanyFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadCompanyFiltersSuccess({ tableKey, result })),
      catchError(error => of(loadCompanyFiltersFailure({ error }))),
    ))))
}
